import refs from '../helpers/refs'
import device from '../helpers/device'
import { throttle } from '../helpers/lodash-custom'

class CFaqLinks {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    // Find all FAQ blocks, compute the Y position and store in an array with the HTML element itself
    // This array gets reversed to make the algoithm easier to implement
    this.faqBlocks = Array.from(document.querySelectorAll('.c-block-faq')).map((elem, index) => {
      const rect = elem.getBoundingClientRect()
      const anchorElem = elem.querySelector('span.c-block-faq__anchor')
      const anchorLinkElem = document.querySelector(`a.c-faq-links__anchor-link[href="#${anchorElem.id}"]`)

      return {
        top: rect.top + window.scrollY,
        bottom: rect.bottom + window.scrollY,
        anchorID: anchorElem.id,
        anchorLinkElem,
        index,
        elem
      }
    }).reverse()
    this.activeFAQBlock = null

    this.init()
    this.initOverlay()
  }

  init () {
    // Throttled to update the nav highlight no more than once every 100ms
    const runNavUpdate = throttle((...args) => this.updateNavHighlight.apply(this, args), 100)

    // Initial active anchor link
    this.updateNavHighlight(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0)

    // On scroll update the active anchor link
    window.addEventListener('scroll', () => {
      // Get scroll position
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
      // Throttle used for performance
      runNavUpdate(scrollTop)
    })

    // On dropdown click, recalculate FAQ block Y positions
    const allDropdowns = document.querySelectorAll('.c-block-faq__checkbox')
    for (const dropdown of allDropdowns) {
      dropdown.addEventListener('change', () => {
        for (let k = 0; k < this.faqBlocks.length; k++) {
          const block = this.faqBlocks[k]
          const rect = block.elem.getBoundingClientRect()

          block.top = rect.top + window.scrollY
          block.bottom = rect.bottom + window.scrollY
        }

        // Recalculate the active FAQ block
        this.updateNavHighlight(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0)
      })
    }
  }

  initOverlay () {
    if (!this.$refs.button || !this.$refs.overlay) {
      return
    }

    this.$refs.button.addEventListener('click', () => {
      this.$refs.overlay.classList.remove('hidden')
    })

    this.$refs.overlay.addEventListener('click', () => {
      this.$refs.overlay.classList.add('hidden')
    })
  }

  updateNavHighlight (scrollTop) {
    // At what point is an FAQ block highlighed as active?
    const threshold = scrollTop + (device.isMobile ? 200 : window.innerHeight * 0.5 - 100)

    /* See if we have a new active FAQ block..
      A) Has the active FAQ not been set yet?
      B) Is the scroll position above the active FAQ block? (ignore if active block is the first one)
      C) Is the scroll position below the active FAQ block? (ignore if active block is the last one)
    */
    if (this.activeFAQBlock === null ||
        (this.activeFAQBlock.index > 0 && threshold < this.activeFAQBlock.top) ||
        (this.activeFAQBlock.index < this.faqBlocks.length - 1 && threshold > this.activeFAQBlock.bottom)) {
      // Scroll left the active FAQ block..
      // Find what the new active FAQ block is
      this.activeFAQBlock = this.faqBlocks.find(({ top }) => top < threshold) || this.faqBlocks.find(({ index }) => index === 0)

      // Update UI
      this.setAnchorHighlight()
    }
  }

  setAnchorHighlight () {
    const oldActiveAnchorLink = document.querySelector('a.c-faq-links__anchor-link--active')
    const newActiveAnchorLink = this.activeFAQBlock.anchorLinkElem

    // Unhighlight the old active anchor link
    if (oldActiveAnchorLink) {
      oldActiveAnchorLink.classList.remove('c-faq-links__anchor-link--active')
    }

    // Highlight the new active anchor link
    if (newActiveAnchorLink) {
      newActiveAnchorLink.classList.add('c-faq-links__anchor-link--active')

      // On mobile, horizontally scroll to show the new active anchor link
      if (device.isMobile()) {
        // Horizontall scroll the c-faq-links container to the show the active anchor link in the center
        const container = document.querySelector('#c-faq-links')

        container.scrollLeft = newActiveAnchorLink.parentNode.offsetLeft -
                              window.screen.width * 0.5 +
                              newActiveAnchorLink.parentNode.offsetWidth * 0.5
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-faq-links')
    .forEach(el => new CFaqLinks(el))
})
